<template>
  <section class="shareCourse">
    <img src="https://cdn.gelonghui.com/webActive/image_share_onlinecourse.png" alt>
    <button @click="gomember">加入会员</button>
  </section>
</template>

<script>
// import axios from "axios"
export default {
  name: "shareCourse",
  data() {
    return {
      val: ""
    };
  },
  created() {},
  mounted() {
    document.title = "会员在线课";
    window.wechatagain = {
      title: "格隆汇至尊会员专属在线课",
      content: "听格隆汇分析师跟你一起谈“资”论道",
      image: "https://cdn.gelonghui.com/webActive/wechat_zaixianke.png"
    };
  },
  methods: {
    gomember() {
      window.location.href =
        "https://www.gelonghui.com/app/device_redirect.html";
    }
  }
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
}

.shareCourse {
  position: relative;
  max-width: 750px;
  padding-bottom: 82px;
  width: 100%;
  margin: 0 auto;
  text-align: center;

  img {
    width: 100%;
  }

  > button {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 88px;
    border: none;
    outline: none;
    text-align: center;
    background: rgba(255, 224, 170, 1);
    font-size: 28px;
    font-weight: 600;
    color: rgba(120, 72, 47, 1);
    line-height: 88px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/member-share/shareCourse.vue